export default {
    props: {
        disabled: {
            type: Boolean,
        },
        scrollContainer: {
            type: [String, HTMLElement],
        },

        target: {
            type: [String, HTMLElement],
        },

        triggers: {
            type: String,
            default: "click",
        },
    },

    computed: {
        attributes() {
            return {
                appendToScrollContainer: true,
                enablePreventOverflow: true,
                enableHide: false,
                disabled: this.disabled,
                placement: "bottom-start",
                target: this.target,
                ref: "popper",
                scrollContainer: this.scrollContainer,
                triggers: this.triggers,
                preventHide: this.shouldPreventHide,
            }
        },

        listeners() {
            return {
                hide: this.$onHide,
                show: this.$onShow,
            }
        },
    },

    methods: {
        $onHide() {
            this.onHide()
            this.$emit("hide")
        },

        onHide() {
        },

        $onShow() {
            this.onShow()
            this.$emit("show")
        },

        onShow() {
        },

        hide() {
            this.$refs.popper.hide()
        },

        show() {
            this.$refs.popper.show()
        },

        moveTo(x, y) {
            this.$refs.popper.moveTo(x, y)
        },

        shouldPreventHide() {
            return false
        },
    },
}
